__turbopack_context__.v({
  "arrow": "PortalNavigation-module__SA8sdW__arrow",
  "inner": "PortalNavigation-module__SA8sdW__inner",
  "link": "PortalNavigation-module__SA8sdW__link",
  "links": "PortalNavigation-module__SA8sdW__links",
  "moreChevron": "PortalNavigation-module__SA8sdW__moreChevron",
  "moreLink": "PortalNavigation-module__SA8sdW__moreLink",
  "morePanel": "PortalNavigation-module__SA8sdW__morePanel",
  "moreTrigger": "PortalNavigation-module__SA8sdW__moreTrigger",
  "navigation": "PortalNavigation-module__SA8sdW__navigation",
  "overflowLink": "PortalNavigation-module__SA8sdW__overflowLink",
  "tabs": "PortalNavigation-module__SA8sdW__tabs",
});
